// frontend/src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ContactForm from './components/ContactForm';
import 'bootstrap/dist/css/bootstrap.min.css';


// Define the mapping of shorthand to full apartment names
const apartmentShorthandMap = {
  CC: "Castle Creek",
  UPA: "University Parkway",
  LA: "Lake Aspen",
  TL: "The Lodges",
  PHF: "Powerhouse Flats",
};

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-100">
        <Routes>
          {/* Static Routes for Each Apartment Shorthand */}
          {Object.entries(apartmentShorthandMap).map(([shorthand, fullName]) => (
            <Route
              key={shorthand}
              path={`/${shorthand}`}
              element={<ContactForm preselectedApartment={fullName} />}
            />
          ))}

          {/* Optional: Home Route */}
          <Route path="/" element={<ContactForm />} />

        </Routes>
      </div>
    </Router>
  );
}



export default App;
